/**
 * Copyright 2026 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { Button } from '@az/starc-ui';
import styles from './AddDealToCartBtn.module.scss';

type Props = {
  addToCartLabel: string;
  onCartAddClick: () => void;
  isSaving: boolean;
  dealId: string;
};

const AddDealToCartBtn = ({ addToCartLabel, onCartAddClick, isSaving, dealId }: Props) => {
  return (
    <div className={styles.bundleDetailsFooter} data-testid="add-to-cart">
      <Button
        onClick={onCartAddClick}
        loading={isSaving}
        data-testid={`deals-drawer-cart-action-button-${dealId}`}
      >
        {addToCartLabel}
      </Button>
    </div>
  );
};

export default AddDealToCartBtn;
